<hr class="mb-5"/>

<div class="container">
  <div class="row justify-content-center mt-5 mb-2">
    <h2>กรุณายืนยันตัวตน ภายในเวลา</h2>
  </div>
  <div class="row justify-content-center border rounded-pill" id="countdown">
    <p> {{message}}</p> 
  </div>


// WEBPACK FOOTER //
// ./src/app/singlegatewaywait/singlegatewaywait.component.html